export const heading_1 = "40px";
export const heading_2 = "32px";
export const heading_3 = "24px";
export const heading_4 = "20px";
export const heading_5 = "16px";
export const heading_6 = "12px";

export const body_1 = "20px";
export const body_2 = "16px";
export const body_3 = "12px";